import {
  CREATE_INVENTORY_QUOTA,
  CREATE_INVENTORY_QUOTA_SUCCESS,
  CREATE_INVENTORY_QUOTA_ERROR,
  CREATE_INVENTORY_QUOTA_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateInventoryQuota = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_INVENTORY_QUOTA:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_INVENTORY_QUOTA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_INVENTORY_QUOTA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_INVENTORY_QUOTA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateInventoryQuota;
